module.exports = __webpack_public_path__ + "static/media/stop-7.9317ac55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-7.svg
// module id = 1352
// module chunks = 0